import Immutable from 'seamless-immutable';
import _ from 'lodash';

const REQUEST_IN_PROGRESS = 'REQUEST_IN_PROGRESS';
const REQUEST_FINISHED = 'REQUEST_FINISHED';
const CHANGE_SERVICE_ARGS = 'CHANGE_SERVICE_ARGS';
const CHANGE_DEFAULT_QUERY_PARAMS = 'CHANGE_DEFAULT_QUERY_PARAMS';
const CHANGE_DYNAMIC_QUERY_PARAMS = 'CHANGE_DYNAMIC_QUERY_PARAMS';
const CHANGE_STATIC_QUERY_PARAMS = 'CHANGE_STATIC_QUERY_PARAMS';
const CALL_EVENT_CHANGE_LOCATION_SEARCH = 'CALL_EVENT_CHANGE_LOCATION_SEARCH';
const SEND_REQUEST = 'SEND_REQUEST';
const UPDATE_LIST = 'UPDATE_LIST';
const ADD_ITEM_TO_UP = 'ADD_ITEM_TO_UP';
const ADD_ITEMS_TO_UP = 'ADD_ITEMS_TO_UP';
const ADD_ITEM_TO_DOWN = 'ADD_ITEM_TO_DOWN';
const REMOVE_ITEM = 'REMOVE_ITEM';
const INIT_STATE = 'INIT_STATE';

const createActionName = (reducerName, name) => `app/${reducerName}/${name}`;
export const getState = (state, reducerName) => {
  const data = _.get(state, reducerName);
  if (data) {
    return Immutable.asMutable(data, {
      deep: true
    });
  }
  return {};
};

const createReducer = parentName => {
  function stateDefault() {
    return {
      requestState: {
        inProgress: false,
        countInProgress: 0,
        lastStatusCode: null,
        countQueries: 0
      },
      mergeItemsMode: false,
      serviceArgs: [],
      defaultQueryParams: {},
      staticQueryParams: {},
      dynamicQueryParams: {},
      eventChangeLocationSearch: 0,
      itemsById: {},
      itemsIds: [],
      total: {},
      pagination: {
        currentPage: 0,
        pageCount: 0,
        perPage: 0,
        totalCount: 0
      }
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(parentName, REQUEST_IN_PROGRESS):
        return state.merge(
          {
            requestState: {
              inProgress: true,
              lastStatusCode: null,
              countInProgress: state.requestState.countInProgress + 1
            }
          },
          { deep: true }
        );
      case createActionName(parentName, REQUEST_FINISHED):
        return state.merge(
          {
            requestState: {
              inProgress: false,
              lastStatusCode: action.payload,
              countQueries: state.requestState.countQueries + 1
            }
          },
          { deep: true }
        );
      case createActionName(parentName, CHANGE_SERVICE_ARGS):
        return state.merge({ serviceArgs: action.payload || [] });
      case createActionName(parentName, CHANGE_DEFAULT_QUERY_PARAMS):
        return state.merge({ defaultQueryParams: action.payload || {} });
      case createActionName(parentName, CHANGE_STATIC_QUERY_PARAMS):
        return state.merge({ staticQueryParams: action.payload || {} });
      case createActionName(parentName, CHANGE_DYNAMIC_QUERY_PARAMS):
        return state.merge(
          { dynamicQueryParams: action.payload || {} },
          { deep: !_.isEmpty(action.payload) }
        );
      case createActionName(parentName, CALL_EVENT_CHANGE_LOCATION_SEARCH):
        return state.merge({
          eventChangeLocationSearch: state.eventChangeLocationSearch + 1
        });
      case createActionName(parentName, SEND_REQUEST):
        if (
          state.mergeItemsMode &&
          (!state.dynamicQueryParams.page ||
            state.dynamicQueryParams.page === 1)
        ) {
          return state.merge({
            itemsById: [],
            itemsIds: []
          });
        }
        return state;
      case createActionName(parentName, UPDATE_LIST):
        if (state.mergeItemsMode) {
          // Для "Show more", не тестировался
          return state.merge({
            itemsById: { ...state.itemsById, ...action.payload.itemsById },
            itemsIds: [...state.itemsIds, ...action.payload.itemsIds],
            pagination: { ...state.pagination, ...action.payload.pagination },
            total: { ...state.total, ...action.payload.total } // TODO Нужно суммировать если showMore
          });
        }
        return state.merge({
          itemsById: action.payload.itemsById,
          itemsIds: action.payload.itemsIds,
          pagination: action.payload.pagination,
          total: action.payload.total
        });
      case createActionName(parentName, ADD_ITEM_TO_UP):
        return state.merge({
          itemsById: {
            ...state.itemsById,
            ...{ [action.payload.itemId]: action.payload.item }
          },
          itemsIds: [...[action.payload.itemId], ...state.itemsIds]
        });
      case createActionName(parentName, ADD_ITEMS_TO_UP):
        return state.merge({
          itemsById: {
            ...state.itemsById,
            ...action.payload.items
          },
          itemsIds: [...action.payload.itemIds, ...state.itemsIds]
        });
      case createActionName(parentName, ADD_ITEM_TO_DOWN):
        return state.merge({
          itemsById: {
            ...state.itemsById,
            ...{ [action.payload.itemId]: action.payload.item }
          },
          itemsIds: [...state.itemsIds, ...[action.payload.itemId]]
        });
      case createActionName(parentName, REMOVE_ITEM): {
        const clone = Immutable.asMutable(state, { deep: true });
        const id = clone.itemsIds.indexOf(action.payload);
        if (id !== -1) clone.itemsIds.splice(id, 1);
        delete clone.itemsById[action.payload];
        return state.merge({
          itemsById: clone.itemsById,
          itemsIds: clone.itemsIds
        });
      }
      case createActionName(parentName, INIT_STATE):
        return Immutable({
          ...stateDefault(),
          ...{ mergeItemsMode: action.payload === true }
        });
      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

// ACTIONS CREATOR
export const requestInProcess = parentName => ({
  type: createActionName(parentName, REQUEST_IN_PROGRESS)
});
export const requestFinished = (parentName, payload) => ({
  type: createActionName(parentName, REQUEST_FINISHED),
  payload
});
export const changeServiceArgs = (parentName, payload) => ({
  type: createActionName(parentName, CHANGE_SERVICE_ARGS),
  payload
});
export const changeQueryParams = (parentName, payload) => ({
  type: createActionName(parentName, CHANGE_DYNAMIC_QUERY_PARAMS),
  payload
});
export const changeDefaultQueryParams = (parentName, payload) => ({
  type: createActionName(parentName, CHANGE_DEFAULT_QUERY_PARAMS),
  payload
});
export const changeStaticQueryParams = (parentName, payload) => ({
  type: createActionName(parentName, CHANGE_STATIC_QUERY_PARAMS),
  payload
});
export const callEventChangeLocationSearch = parentName => ({
  type: createActionName(parentName, CALL_EVENT_CHANGE_LOCATION_SEARCH)
});
export const sendRequest = (parentName, payload) => ({
  type: createActionName(parentName, SEND_REQUEST),
  payload
});
export const updateList = (parentName, payload) => ({
  type: createActionName(parentName, UPDATE_LIST),
  payload
});
export const addItemToUp = (parentName, itemId, item) => ({
  type: createActionName(parentName, ADD_ITEM_TO_UP),
  payload: { itemId, item }
});
export const addItemsToUp = (parentName, itemIds, items) => ({
  type: createActionName(parentName, ADD_ITEMS_TO_UP),
  payload: { itemIds, items }
});
export const addItemToDown = (parentName, payload) => ({
  type: createActionName(parentName, ADD_ITEM_TO_DOWN),
  payload
});
export const removeItem = (parentName, payload) => ({
  type: createActionName(parentName, REMOVE_ITEM),
  payload
});
export const initState = (parentName, payload) => ({
  type: createActionName(parentName, INIT_STATE),
  payload
});

// SELECTORS
export const selectRequestState = (state, parentName) =>
  getState(state, parentName).requestState;
export const selectServiceArgs = (state, parentName) =>
  getState(state, parentName).serviceArgs;
export const selectQueryParams = (state, parentName) => ({
  ...getState(state, parentName).defaultQueryParams,
  ...getState(state, parentName).dynamicQueryParams,
  ...getState(state, parentName).staticQueryParams
});
export const selectDynamicQueryParams = (state, parentName) => ({
  ...getState(state, parentName).dynamicQueryParams
});
export const selectVisibleQueryParams = (state, parentName) => ({
  ...getState(state, parentName).defaultQueryParams,
  ...getState(state, parentName).dynamicQueryParams
});
export const selectEventChangeLocationSearch = (state, parentName) =>
  getState(state, parentName).eventChangeLocationSearch;
export const selectItemsIds = (state, parentName) =>
  getState(state, parentName).itemsIds;
export const selectItemById = (state, parentName, itemId) =>
  getState(state, parentName).itemsById[itemId];
export const selectPagination = (state, parentName) =>
  getState(state, parentName).pagination;
export const selectTotal = (state, parentName) =>
  getState(state, parentName).total;



// WEBPACK FOOTER //
// ./src/mt-react-common/common/reducers/list/reducer.js